angular.module('bmsApp.reports')
	.controller('CustomerRetentionReportCtrl', CustomerRetentionReportCtrl);

AnnualRevenueComparisonCtrl.$inject = [
	'$scope',
	'$state',
	'$q',
];

function CustomerRetentionReportCtrl($scope, $state, $q) {
	let self = this;
	let handlers = {};

	angular.extend(self, {
		loading: true,
		handlers: handlers,
	});

	this.$onInit = () => {
	};

	$scope.$watch(function () {
		return $scope.ReportIndex.selectedReport.additionalData;
	}, function (value) {
		if (angular.isObject(value)) {
			setAdditionalData();
		}
	});

	function setAdditionalData() {
		let data = $scope.ReportIndex.selectedReport.additionalData;
		self.summary = data.summary;
		self.categories = [];
		angular.forEach(data.chart_data, function(chartData){
			self.categories.push(chartData.month_and_year)
		});

		self.seriesData = [];
		angular.forEach(data.chart_data, function(chartData){
			self.seriesData.push(chartData.total_visits)
		});
		self.series = [];
		self.series.push({
			type: 'column',
			name: 'Visits',
			data: self.seriesData,
			color: '#7ABE43',
			lineWidth: 4,
			marker: {
				lineWidth: 3,
				lineColor: 'orange',
				fillColor: 'white'
			}
		});

		setChart();
		self.loading = false;
	}

	// Handlers --------------------------------------------------------------------------------------------------------
	handlers.submitClick = function () {

	};


	function setChart() {
		self.chart = {
			revenue: {
				title: {
					text: 'Customer Retention'
				},
				subtitle: {
					text: '',
					style: {
						color: '#AAA'
					}
				},
				credits: false,
				xAxis: [
					{
						categories: self.categories,
					}
				],
				yAxis: [
					{
						labels: {
							format: '{value}'
						},
						title: {
							text: ''
						}
					}
				],
				tooltip: {
					valuePrefix: ''
				},
				series: self.series,
			}
		};
		self.chartObjs = {};
	}
}
